module.exports = __webpack_public_path__ + "media/images/twitter-c429541c6fafe08a8a813f8d3472968b.svg";